import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FdaEditComponent } from './fda-edit.component';

const routes: Routes = [
  {
    path: '',
    component: FdaEditComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FdaEditRoutingModule {}
